import type { LucideIcon } from "lucide-react";
import { AlertCircle, CheckCircle2, Clock } from "lucide-react";

type ApplicationStateVariant = "default" | "secondary" | "outline" | "destructive";

export type ApplicationStateConfigItem = {
  label: string;
  variant: ApplicationStateVariant;
  icon?: LucideIcon;
};

export type ApplicationStateConfig = Record<string, ApplicationStateConfigItem>;

export const REFUND_APPLICATION_STATE_CONFIG: ApplicationStateConfig = {
  new: { label: "На рассмотрении", variant: "default" },
  in_work: { label: "В работе", variant: "secondary" },
  complete: { label: "Обработано", variant: "outline" },
};

export const FREEZE_APPLICATION_STATE_CONFIG: ApplicationStateConfig = {
  new: { label: "На рассмотрении", variant: "default", icon: Clock },
  in_work: { label: "В работе", variant: "secondary", icon: Clock },
  clarification: { label: "Вопрос от менеджера", variant: "destructive", icon: AlertCircle },
  complete: { label: "Обработано", variant: "outline", icon: CheckCircle2 },
};
